export default __webpack_public_path__ + "static/media/cleaning_vertical.d922938b.png";